
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'1-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            시스템 관리 - 메뉴권한 {{ $route.query.menu_permission_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.menu_permission_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='menu_permission_name'>메뉴 권한명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'menu_permission_name'
                maxLength="50"
                placeholder = "메뉴 권한명을 입력해 주세요."
                v-model="formData.menuPermissionName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.menuPermissionNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='menu_permission_status'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="menu_permission_status"
                v-model="formData.menuPermissionStatus"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

          <div class="Admin_PermissionBox">
            <div class="Admin_Permission_MainDiv">
              <label for='checkbox_menu_1' class="Admin_labelCheck Admin_labelCheck_First">
                시스템 관리
                <input
                type='checkbox'
                id = 'checkbox_menu_1'
                v-on:click="insert_menu_permission_check_box_all($event, ['1', '1-1', '1-2'])"
                :checked="check_box_bool_judgement('1')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_1_1' class="Admin_labelCheck">
                메뉴권한 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_1_1'
                  v-on:click="insert_menu_permission_check_box($event, '1', '1-1')"
                  :checked="check_box_bool_judgement('1-1')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_1_2' class="Admin_labelCheck">
                사용자 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_1_2'
                  v-on:click="insert_menu_permission_check_box($event, '1', '1-2')"
                  :checked="check_box_bool_judgement('1-2')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>
          </div>

          <div class="Admin_PermissionBox">
            <div class="Admin_Permission_MainDiv">
              <label for='checkbox_menu_4' class="Admin_labelCheck Admin_labelCheck_First">
                회원 관리
                <input
                type='checkbox'
                id = 'checkbox_menu_4'
                v-on:click="insert_menu_permission_check_box_all($event, ['4', '4-1', '4-2'])"
                :checked="check_box_bool_judgement('4')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_4_1' class="Admin_labelCheck">
                회원 현황
                <input
                  type='checkbox'
                  id = 'checkbox_menu_4_1'
                  v-on:click="insert_menu_permission_check_box($event, '4', '4-1')"
                  :checked="check_box_bool_judgement('4-1')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_4_2' class="Admin_labelCheck">
                쿠폰 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_4_2'
                  v-on:click="insert_menu_permission_check_box($event, '4', '4-2')"
                  :checked="check_box_bool_judgement('4-2')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>
          </div>

          <div class="Admin_PermissionBox">
            <div class="Admin_Permission_MainDiv">
              <label for='checkbox_menu_5' class="Admin_labelCheck Admin_labelCheck_First">
                메뉴 관리
                <input
                type='checkbox'
                id = 'checkbox_menu_5'
                v-on:click="insert_menu_permission_check_box_all($event, ['5', '5-1'])"
                :checked="check_box_bool_judgement('5')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_5_1' class="Admin_labelCheck">
                메뉴 현황
                <input
                  type='checkbox'
                  id = 'checkbox_menu_5_1'
                  v-on:click="insert_menu_permission_check_box($event, '5', '5-1')"
                  :checked="check_box_bool_judgement('5-1')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>
          </div>

          <div class="Admin_PermissionBox">
            <div class="Admin_Permission_MainDiv">
              <label for='checkbox_menu_2' class="Admin_labelCheck Admin_labelCheck_First">
               메인화면 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_2'
                  v-on:click="insert_menu_permission_check_box_all($event, ['2', '2-1', '2-2', '2-3', '2-4', '2-5', '2-6', '2-7', '2-8', '2-9', '2-10'])"
                  :checked="check_box_bool_judgement('2')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_2_1' class="Admin_labelCheck">
                롤링배너 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_2_1'
                  v-on:click="insert_menu_permission_check_box($event, '2', '2-1')"
                  :checked="check_box_bool_judgement('2-1')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_2_2' class="Admin_labelCheck">
                QUICK DELIVERY 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_2_2'
                  v-on:click="insert_menu_permission_check_box($event, '2', '2-2')"
                  :checked="check_box_bool_judgement('2-2')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_2_3' class="Admin_labelCheck">
                NFU PICK 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_2_3'
                  v-on:click="insert_menu_permission_check_box($event, '2', '2-3')"
                  :checked="check_box_bool_judgement('2-3')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_2_4' class="Admin_labelCheck">
                MONTHLY BEST 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_2_4'
                  v-on:click="insert_menu_permission_check_box($event, '2', '2-4')"
                  :checked="check_box_bool_judgement('2-4')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_2_5' class="Admin_labelCheck">
                LIVING ACC 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_2_5'
                  v-on:click="insert_menu_permission_check_box($event, '2', '2-5')"
                  :checked="check_box_bool_judgement('2-5')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_2_6' class="Admin_labelCheck">
                STYLING 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_2_6'
                  v-on:click="insert_menu_permission_check_box($event, '2', '2-6')"
                  :checked="check_box_bool_judgement('2-6')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_2_7' class="Admin_labelCheck">
                인스타그램 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_2_7'
                  v-on:click="insert_menu_permission_check_box($event, '2', '2-7')"
                  :checked="check_box_bool_judgement('2-7')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_2_8' class="Admin_labelCheck">
                탑 배너 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_2_8'
                  v-on:click="insert_menu_permission_check_box($event, '2', '2-8')"
                  :checked="check_box_bool_judgement('2-8')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_2_9' class="Admin_labelCheck">
                배너 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_2_9'
                  v-on:click="insert_menu_permission_check_box($event, '2', '2-9')"
                  :checked="check_box_bool_judgement('2-9')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_2_10' class="Admin_labelCheck">
                팝업 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_2_10'
                  v-on:click="insert_menu_permission_check_box($event, '2', '2-10')"
                  :checked="check_box_bool_judgement('2-10')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
          </div>

          <div class="Admin_PermissionBox">
            <div class="Admin_Permission_MainDiv">
              <label for='checkbox_menu_3' class="Admin_labelCheck Admin_labelCheck_First">
                제품 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_3'
                  v-on:click="insert_menu_permission_check_box_all($event, ['3', '3-1', '3-2', '3-3', '3-4', '3-5'])"
                  :checked="check_box_bool_judgement('3')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_3_1' class="Admin_labelCheck">
                브랜드 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_3_1'
                  v-on:click="insert_menu_permission_check_box($event, '3', '3-1')"
                  :checked="check_box_bool_judgement('3-1')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_3_2' class="Admin_labelCheck">
                1단계 : 제품 타입 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_3_2'
                  v-on:click="insert_menu_permission_check_box($event, '3', '3-2')"
                  :checked="check_box_bool_judgement('3-2')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_3_3' class="Admin_labelCheck">
                2단계 : 제품 분류 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_3_3'
                  v-on:click="insert_menu_permission_check_box($event, '3', '3-3')"
                  :checked="check_box_bool_judgement('3-3')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_3_4' class="Admin_labelCheck">
                3단계 : 제품 분류 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_3_4'
                  v-on:click="insert_menu_permission_check_box($event, '3', '3-4')"
                  :checked="check_box_bool_judgement('3-4')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_3_5' class="Admin_labelCheck">
                제품 등록 및 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_3_5'
                  v-on:click="insert_menu_permission_check_box($event, '3', '3-5')"
                  :checked="check_box_bool_judgement('3-5')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>
          </div>

          <div class="Admin_PermissionBox">
            <div class="Admin_Permission_MainDiv">
              <label for='checkbox_menu_6' class="Admin_labelCheck Admin_labelCheck_First">
                주문 / 배송 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_6'
                  v-on:click="insert_menu_permission_check_box_all($event, ['6', '6-1','6-2'])"
                  :checked="check_box_bool_judgement('6')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_6_1' class="Admin_labelCheck">
                주문 현황
                <input
                  type='checkbox'
                  id = 'checkbox_menu_6_1'
                  v-on:click="insert_menu_permission_check_box($event, '6', '6-1')"
                  :checked="check_box_bool_judgement('6-1')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_6_2' class="Admin_labelCheck">
                바로결제 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_6_2'
                  v-on:click="insert_menu_permission_check_box($event, '6', '6-2')"
                  :checked="check_box_bool_judgement('6-2')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_menu_permission_one,
  insert_menu_permission,
  update_menu_permission
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminMenuPermissionManagementAdd',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter,
    Spiner: Spiner

  },
  setup () {
    return {
      formData: ref({
        menuPermissionName: '',
        menuPermissionStatus: 1,
        menuPermissionArray: []
      }),
      errorData: ref({
        menuPermissionNameError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    check_box_bool_judgement: function (menu_ID) {
      let bool = false
      for (let i = 0; i < this.formData.menuPermissionArray.length; i++) {
        if (this.formData.menuPermissionArray[i] === menu_ID) {
          bool = true
        }
      }
      return bool
    },
    insert_menu_permission_check_box: function (event, big_menu_ID, menu_ID) {
      if (event.target.checked === true) {
        if (!this.check_box_bool_judgement(big_menu_ID)) {
          this.formData.menuPermissionArray.push(big_menu_ID)
        }
        this.formData.menuPermissionArray.push(menu_ID)
      } else {
        for (let i = 0; i < this.formData.menuPermissionArray.length; i++) {
          if (this.formData.menuPermissionArray[i] === menu_ID) {
            this.formData.menuPermissionArray.splice(i, 1)
            i--
          }
        }
      }
    },
    insert_menu_permission_check_box_all: function (event, menu_ID) {
      menu_ID.forEach(element => {
        if (event.target.checked === true) {
          if (!this.check_box_bool_judgement(element)) {
            this.formData.menuPermissionArray.push(element)
          }
        } else {
          for (let i = 0; i < this.formData.menuPermissionArray.length; i++) {
            if (this.formData.menuPermissionArray[i] === element) {
              this.formData.menuPermissionArray.splice(i, 1)
              i--
            }
          }
        }
      })
    },
    check_form: function () {
      let continue_add = true
      if (this.formData.menuPermissionName === '') {
        this.errorData.menuPermissionNameError = '메뉴 권한명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.menuPermissionNameError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.menu_permission_ID === undefined) {
          insert_menu_permission(
            this.formData.menuPermissionName,
            this.formData.menuPermissionStatus,
            JSON.stringify(this.formData.menuPermissionArray)
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminMenuPermissionManagement'
          })
        } else {
          update_menu_permission(
            this.$route.query.menu_permission_ID,
            this.formData.menuPermissionName,
            this.formData.menuPermissionStatus,
            JSON.stringify(this.formData.menuPermissionArray)
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminMenuPermissionManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.menu_permission_ID !== undefined) {
      get_menu_permission_one(this.$route.query.menu_permission_ID).then((result) => {
        this.formData.menuPermissionArray = JSON.parse(result[0].menu_permission_array)
        this.formData.menuPermissionName = result[0].menu_permission_name
        this.formData.menuPermissionStatus = result[0].menu_permission_status
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/SystemManagement/AdminMenuPermissionManagementAdd.vue